module.exports = __webpack_public_path__ + "static/img/13.cc007a20.png";